export const mainNavigation = [
  {
    label: 'Company',
    children: [
      { label: 'About NCPL', to: '/about' },
      { label: 'Team', to: '/team' },
      { label: 'Customers', to: '/customers' },
    ],
  },
  {
    label: 'Capabilities',
    children: [
      { label: 'Products', to: '/products' },
      { label: 'Manufacturing', to: '/manufacturing' },
    ],
  },
  { label: 'Responsibility', to: '/responsibility' },
  { label: 'Global Sourcing', to: '/global-sourcing' },
  { label: 'Careers', to: '/careers' },
];

export const footerCompany = [
  { label: 'About', to: '/about' },
  { label: 'Our Team', to: '/team' },
  { label: 'Careers', to: '/careers' },
  { label: 'Customers', to: '/customers' },
  { label: 'Responsibility', to: '/responsibility' },
];

export const footerCapabilities = [
  { label: 'Products', to: '/products' },
  { label: 'Manufacturing', to: '/manufacturing' },
];

export const footerSourcing = [
  { label: 'Why NCPL', to: '/global-sourcing#why-ncpl' },
  { label: 'Sourcing Process', to: '/global-sourcing#sourcing-process' },
  { label: 'Enquiry', to: '/contact#enquiry' },
];

export const cta = {
  label: 'Sourcing Enquiry',
  to: '/contact#enquiry',
};

export const legacyRedirects = [
  { from: '/partnerships', to: '/about' },
  { from: '/capabilities', to: '/manufacturing' },
  { from: '/quality', to: '/manufacturing' },
  { from: '/responsible-manufacturing', to: '/responsibility' },
  { from: '/leadership', to: '/team' },
];

export function flattenNavigation(items = mainNavigation) {
  return items.flatMap((item) => (item.children ? item.children : [item]));
}
